import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarGroupsState {
  collapsedGroups: Record<string, boolean>;
  toggleGroup: (labelKey: string) => void;
  setGroupCollapsed: (labelKey: string, collapsed: boolean) => void;
  expandGroup: (labelKey: string) => void;
}

export const useSidebarGroupsStore = create<SidebarGroupsState>()(
  persist(
    (set) => ({
      collapsedGroups: {},
      toggleGroup: (k) =>
        set((s) => ({
          collapsedGroups: { ...s.collapsedGroups, [k]: !s.collapsedGroups[k] },
        })),
      setGroupCollapsed: (k, collapsed) =>
        set((s) => ({
          collapsedGroups: { ...s.collapsedGroups, [k]: collapsed },
        })),
      expandGroup: (k) =>
        set((s) =>
          s.collapsedGroups[k]
            ? { collapsedGroups: { ...s.collapsedGroups, [k]: false } }
            : s
        ),
    }),
    {
      name: 'beetegre-sidebar-groups',
      partialize: (state) => ({ collapsedGroups: state.collapsedGroups }),
    }
  )
);
